export function col3to6(color: string): string {
    if (color.startsWith('#')) {
        color = color.substring(1);
    }

    if (color.length == 6) {
        return color;
    }

    if (color.length != 3) {
        console.log(`invalid color ${color}`);
    }

    let r = parseInt(color.substring(0, 1), 16) || 0;
    let g = parseInt(color.substring(1, 2), 16) || 0;
    let b = parseInt(color.substring(2, 3), 16) || 0;

    const rs = (16 * r + r).toString(16).padStart(2, '0');
    const gs = (16 * g + g).toString(16).padStart(2, '0');
    const bs = (16 * b + b).toString(16).padStart(2, '0');
    return rs + gs + bs;
}

export function shadeColor(color: string, p: number): string {
    if (!color.startsWith('#')) {
        color = `#${color}`;
    }

    color = col3to6(color);

    let r = parseInt(color.substring(0, 2), 16) || 0;
    let g = parseInt(color.substring(2, 4), 16) || 0;
    let b = parseInt(color.substring(4, 6), 16) || 0;

    r = r * p;
    g = g * p;
    b = b * p;

    r = Math.max(Math.min(r, 255), 0);
    g = Math.max(Math.min(g, 255), 0);
    b = Math.max(Math.min(b, 255), 0);

    r = Math.floor(r)
    g = Math.floor(g)
    b = Math.floor(b)

    const rs = r.toString(16).padStart(2, '0');
    const gs = g.toString(16).padStart(2, '0');
    const bs = b.toString(16).padStart(2, '0');
    return rs + gs + bs;
}

export function invertColor(color: string): string {
    if (!color.startsWith('#')) {
        color = `#${color}`;
    }

    color = col3to6(color);

    let r = parseInt(color.substring(0, 2), 16) || 0;
    let g = parseInt(color.substring(2, 4), 16) || 0;
    let b = parseInt(color.substring(4, 6), 16) || 0;

    console.log(`invert: ${color} -> ${r} ${g} ${b}`);

    r = 255 - r;
    g = 255 - g;
    b = 255 - b;

    r = Math.max(Math.min(r, 255), 0);
    g = Math.max(Math.min(g, 255), 0);
    b = Math.max(Math.min(b, 255), 0);

    r = Math.floor(r)
    g = Math.floor(g)
    b = Math.floor(b)

    const rs = r.toString(16).padStart(2, '0');
    const gs = g.toString(16).padStart(2, '0');
    const bs = b.toString(16).padStart(2, '0');
    return rs + gs + bs;
}
